'use client';

import { useAppSelector } from './storeHooks';
import { STORAGE } from '../../_config';

export function useAuthStatus() {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  return isAuthenticated;
}

export function useAccessToken() {
  const token = useAppSelector((state) => state.auth.token);
  return token;
}

export function checkPersistedAuth() {
  try {
    const storageData = localStorage.getItem(STORAGE);
    if (!storageData) return false;
    
    const userData = JSON.parse(storageData);
    if (!userData || !userData.accessToken) return false;
    
    // Check if token is expired
    if (userData.expires_at && new Date(userData.expires_at) < new Date()) {
      return false;
    }
    
    return true;
  } catch (error) {
    console.error("Error checking persisted auth:", error);
    return false;
  }
}
